import "../uber.css";

import "../hero/hero.css";
// import HeroGif from '../hero/Uber-Eats-Award-Black-700x700_CRM.gif';
import HeroBurger from '../hero/burger-1.png';
import HeroSalad from '../hero/salad-1.png';
import { HeroAnimation } from "../hero/Hero";

import HeroLogo from '../../uber-assets/ROTYlogo_500x250.png';

import { Nav } from "../components/nav";
import { AboutHeader } from "../components/about-header";
import { ROTYSection } from "../components/roty-section";
import { TrailblazersSection } from "../components/trailblazers-section";
import { PreviousWinnersSection } from "../components/previous-winners-section";
import { FaqSection } from "../components/faq-section";
import { Footer } from "../components/footer";

import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { InfoPopout } from "../components/info-popout/info-popout";
import { useEffect, useRef, useState } from "react";

import nl2br from "react-nl2br";
import { INSTA_ICON, ROTY_WINNER_ICON, SHARE_ICON, FEMALE_CHEF_ICON, SOCIAL_IMPACT_ICON, SUSTAINABLE_RESTAURANT_ICON, HEALTH_FOCUSED_ICON } from "../../uber-assets/inline-svgs";
import { AREAS_BY_ID, findRegionData } from "../model/areas";

import LocationIcon from '../../uber-assets/location-icon.svg';
import { PrevWinnerCard } from "../components/prev-winner-card/prev-winner-card";
import { PREV_WINNERS } from "../model/prev-winners";
import Carousel from "react-multi-carousel";
import { CustomDot } from "../components/carousel/custom-dot";
import API_CONTROLLER, { RECAPTCHA_STATE } from "../controller/ApiController";
import ReCAPTCHA from "react-google-recaptcha";
import { v4 as uuidv4 } from 'uuid';
import { FORCE_RESTAURANT_PLACEHOLDER, PHASES, getPhase, CACHE_BUSTING_VERSION } from "../model/phases";

import { fb } from "../controller/ShareController";
import { FB_HASHTAGS, SHARE_MESSAGE, SHARE_RAW_HASHTAGS } from "../model/sharing";
import { findRestaurantData, GetPreviousOverallWinner, getRestaurantUrlSlug, logOutrestaurantNamesArray, RESTAURANT_PLACEHOLDER, RESTAURANT_SHORTLIST } from "../model/restaurants";
import { findCategoryData, TRAILBLAZER_CATEGORIES } from "../model/trailblazer-categories";
import { EMPTY_TRAILBLAZER, findNomineeData } from "../model/trailblazer-nominees";
import { ComingSoon } from "../components/coming-soon";
import FireWorksController from "../controller/Fireworks";
import { RestaurantCard } from "../components/restaurant-card/restaurant-card";

const HeroAnimationInstance = null;

export function Main() {
    gsap.registerPlugin(ScrollToPlugin);

    useEffect(() => {
        // Initialize the hero animation
        if (!HeroAnimationInstance) {
            new HeroAnimation();
        }
    }, []);

    const SECTION_ANIM_IN_OFFSET = 80;
    const INITIAL_LOAD_ANIM_IN_Y_OFFSET = 40;
    const sectionAnimatedIn = useRef([]);
    const [scrollY, setScrollY] = useState(0);
    const scrollAnimInHandler = (e, initialLoad = false) => {
        const scrollY = window.scrollY;
        setScrollY(scrollY);
        const windowHeight = window.innerHeight;
        const sections = document.querySelectorAll('section');
        sections.forEach((section) => {
            if (sectionAnimatedIn.current.indexOf(section) === -1) {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.offsetHeight;
                if (scrollY + windowHeight - (initialLoad ? INITIAL_LOAD_ANIM_IN_Y_OFFSET : SECTION_ANIM_IN_OFFSET) > sectionTop && scrollY < sectionTop + sectionHeight) {
                    if (section.classList.contains('section-anim-in')) {
                        return;
                    }
                    section.classList.add('section-anim-in');
                    sectionAnimatedIn.current.push(section);
                }
            }
        });
        const cards = document.querySelectorAll('.card-anim-start');
        let cardAnimDelay = 0;
        cards.forEach((card) => {
            if (scrollY + windowHeight - SECTION_ANIM_IN_OFFSET > card.offsetTop) {
                if (card.classList.contains('card-anim-in') || card.classList.contains('card-anim-out')) {
                    return;
                }
                card.classList.add('card-anim-in');
                card.style.animationDelay = (cardAnimDelay * 0.1) + 's';
                cardAnimDelay++;
            }
        });
    }
    useEffect(() => {
        setTimeout(() => {
            window.addEventListener('scroll', scrollAnimInHandler);
            scrollAnimInHandler(null, true);

            /* console.log('----- RESTAURANT LIST FOR PHP API -----');
            let rList = (`$r_names=[\n  '',\n`);
            for (let i = 0; i < RESTAURANT_SHORTLIST.length; i++) {
                rList += (`  '${RESTAURANT_SHORTLIST[i].name}',\n`);
            }
            rList += ('];\n');
            console.log(rList);
            console.log('----- END RESTAURANT LIST -----'); */
        }, 800);
        
        setTimeout(() => {
            FireWorksController.start();
        }, 100);
        
        return () => {
            window.removeEventListener('scroll', scrollAnimInHandler);
        }
    }, []);

    const cardTransitionOutFunction = (cardClassToFind, tranitionOverCallback) => {
        const cards = document.querySelectorAll('.' + cardClassToFind);
        let cardAnimDelay = 0;
        cards.forEach((card) => {
            if (card.classList.contains('card-anim-out')) {
                return;
            }
            card.classList.remove('card-anim-in');
            card.classList.remove('card-anim-start');
            card.classList.add('card-anim-out');
            card.style.animationDelay = (cardAnimDelay * 0.1) + 's';
            cardAnimDelay++;
            if (cardAnimDelay > 6) {
                cardAnimDelay = 6;
            }
        });
        setTimeout(() => {
            if (tranitionOverCallback) {
                tranitionOverCallback();
            }
        }, cardAnimDelay * 100 + 200);
    }

    const cardTransitionInFunction = (cardClassToFind, tranitionOverCallback) => {
        const cards = document.querySelectorAll('.' + cardClassToFind);
        let cardAnimDelay = 0;
        cards.forEach((card) => {
            if (card.classList.contains('card-anim-in')) {
                return;
            }
            card.classList.remove('card-anim-out');
            card.classList.add('card-anim-start');
            card.classList.add('card-anim-in');
            card.style.animationDelay = (cardAnimDelay * 0.2) + 's';
            cardAnimDelay++;
            if (cardAnimDelay > 9) {
                cardAnimDelay = 9;
            }
        });
        setTimeout(() => {
            if (tranitionOverCallback) {
                tranitionOverCallback();
            }
        }, cardAnimDelay * 200 + 700);
    }

    const scrollToSection = (sectionId, mobile = false) => {
        // document.getElementById(sectionId).scrollIntoView({behavior: 'smooth'});
        gsap.to(window, { duration: 0.5, scrollTo: { y: `#${sectionId}`, offsetY: sectionId === 'top' ? 170 : mobile ? 70 : 70 } });
    }

    const openLink = (url) => {
        window.open(url, '_blank');
    }

    const goToInstagram = (winner) => {
        const insta = winner.instagram;
        if (insta.indexOf('instagram.com') === -1) {
            openLink('https://www.instagram.com/' + insta);
        } else {
            openLink(winner.instagram?.startsWith('https://') ? winner.instagram : 'https://' + winner.instagram);
        }
    }

    const goToOrder = (winner) => {
        openLink(winner.orderlink?.startsWith('https://') ? winner.orderlink : 'https://' + winner.orderlink);
    }

    const share = (restaurantData, restaurantId = -1) => {
        let shareLink = 'https://www.ubereatsawards.com/';
        if (restaurantId !== -1) {
            shareLink += '?r=' + (getRestaurantUrlSlug(restaurantId) || restaurantId);
        }
        // console.log('Sharing restaurant', restaurantData, 'with ID', restaurantId, 'and link', shareLink);
        const customMessage = restaurantId === -1 ? ' ' : ' I voted for ' + restaurantData.name + ', who will you vote for? ';
        const shareTag = restaurantId === -1 ? FB_HASHTAGS : FB_HASHTAGS + ' #VoteNow #' + restaurantData.name.replace(/ /g, '');
        fb.share_ui(SHARE_MESSAGE + customMessage + SHARE_RAW_HASHTAGS, shareTag, shareLink);
    }

    const [showingPreviousWinners, setShowingPreviousWinners] = useState(false);
    const previousWinnersClosedCallback = () => {
        setShowingPreviousWinners(false);
    }
    const showPreviousWinners = () => {
        setShowingPreviousWinners(true);
    }

    const [showingRestaurantInfo, setShowingRestaurantInfo] = useState(false);
    const [restaurantInfoData, setRestaurantInfoData] = useState(null);
    const restaurantInfoClosedCallback = () => {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.hash}`);
        setShowingRestaurantInfo(false);
    }
    const showRestaurantInfo = (restaurantInfoData) => {
        console.log('Showing restaurant info for: ', restaurantInfoData);
        window.history.replaceState(null, '', `?r=${restaurantInfoData.slug || getRestaurantUrlSlug(restaurantInfoData.id) || restaurantInfoData.id}`);
        setRestaurantInfoData(restaurantInfoData);
        setShowingRestaurantInfo(true);
    }

    const [showingTrailblazerInfo, setShowingTrailblazerInfo] = useState(false);
    const [trailblazerInfoData, setTrailblazerInfoData] = useState(null);
    const trailblazerInfoClosedCallback = () => {
        setShowingTrailblazerInfo(false);
    }
    const showTrailblazerInfo = (trailblazerInfoData) => {
        setTrailblazerInfoData(trailblazerInfoData);
        setShowingTrailblazerInfo(true);
    }

    // Voting
    const [recaptchaState, setRecaptchaState] = useState(RECAPTCHA_STATE.LOADING),
        [recaptchaToken, setRecaptchaToken] = useState(null),
        [showRecaptcha, setShowRecaptcha] = useState(false),
        [lastVote, setLastVote] = useState(null),
        [lastVotedRestaurantName, setLastVotedRestaurantName] = useState(null),
        [lastRegion, setLastRegion] = useState(null),
        [guid, setGuid] = useState(null),
        [email, setEmail] = useState(''),
        [currentVotes, setCurrentVotes] = useState([]),
        [currentVotesWithEmails, setCurrentVotesWithEmails] = useState([]),
        [currentPhase, setCurrentPhase] = useState(null);
    const [showVoteConfirmation, setShowVoteConfirmation] = useState(false);

    const [phaseRefresh, setPhaseRefresh] = useState(false);
    const refreshPhase = () => {
        const phaseData = getPhase();
        setCurrentPhase((oldVal) => {
            if (oldVal === PHASES.LAUNCHING_SOON && phaseData.phase !== PHASES.LAUNCHING_SOON) {
                setPhaseRefresh(true);
            }
            return phaseData.phase;
        });
        if (phaseData.timeLeft > 0) {
            setTimeout(refreshPhase, phaseData.timeLeft * 1000);
        }
    }
    useEffect(() => {
        // Refresh the window
        if (phaseRefresh) {
            window.location.reload();
        }
    }, [phaseRefresh]);

    const storageAvailable = (type = "localStorage") => {
        let storage;
        try {
            storage = window[type];
            const x = "__storage_test__";
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return (
                e instanceof DOMException &&
                // everything except Firefox
                (e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === "QuotaExceededError" ||
                    // Firefox
                    e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage &&
                storage.length !== 0
            );
        }
    }

    const [voteRegistered, setVoteRegistered] = useState(false);
    const registerVote = (vote, region, restaurantName, skipRecaptcha = false) => {
        // disable voting for now
        // return;

        let voteIndex = vote;
        // Allow us to submit the vote by index or by restaurant data object
        if (typeof voteIndex !== 'number') {
            if (voteIndex.id) {
                voteIndex = voteIndex.id;
            } else {
                console.error('Invalid vote: ', vote);
                return;
            }
        }

        if (currentVotes.indexOf(voteIndex) === -1) {
            // if (!skipRecaptcha && recaptchaState !== RECAPTCHA_STATE.VERIFIED) {
                setLastVote(voteIndex);
                setLastVotedRestaurantName(restaurantName);
                setLastRegion(region);
                setRecaptchaState(RECAPTCHA_STATE.READY);
                setRecaptchaToken(null);
                setShowRecaptcha(true);
                setVoteRegistered(false);
            /* } else {
                let votes = currentVotes;
                votes.push(voteIndex);
                setCurrentVotes(votes);
                setLastVote(null);
                setLastRegion(null);
                API_CONTROLLER.PostVote(voteIndex, guid, recaptchaToken, region);
                // document.cookie = 'votes = ' + votes.join(',');
                if (storageAvailable()) {
                    localStorage.setItem('votes', votes.join(','));
                }

                setRecaptchaState(RECAPTCHA_STATE.LOADING);
                setRecaptchaToken(null);
                setShowRecaptcha(false);
            } */
        }
    }

    const captchaOnChange = (value) => {
        // console.log("Captcha value:", value);
        setRecaptchaState(value === null ? RECAPTCHA_STATE.READY : RECAPTCHA_STATE.VERIFIED);
        setRecaptchaToken(value);
        /* if (value !== null) {
            // setShowRecaptcha(false);
            if (lastVote !== null && lastRegion !== null) {
                registerVote(lastVote, lastRegion, true);
            }
        } */
    }

    const isValidEmail = (email) => {
        // Simple email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const submitVoteNow = () => {
        // if email is a valid email address and recaptchaState === RECAPTCHA_STATE.VERIFIED) {
        if (email && recaptchaState === RECAPTCHA_STATE.VERIFIED) {
            // validate email
            if (!isValidEmail(email)) {
                // alert('Please enter a valid email address.');
                return;
            }

            let voteIndex = lastVote;
            let votes = currentVotes;
            votes.push(voteIndex);
            setCurrentVotes(votes);
            setLastVote(null);
            setLastRegion(null);
            API_CONTROLLER.PostVote(voteIndex, lastVotedRestaurantName, guid, recaptchaToken, lastRegion, email);
            // document.cookie = 'votes = ' + votes.join(',');
            if (storageAvailable()) {
                localStorage.setItem('votes_2026', votes.join(','));
                localStorage.setItem('votes_with_emails_2026', votes.map(v => `${v}:${email}`).join(','));
            }

            setRecaptchaState(RECAPTCHA_STATE.LOADING);
            setRecaptchaToken(null);
            // setShowRecaptcha(false);
            setVoteRegistered(true);
        }
    }

    useEffect(() => {
        // logOutrestaurantNamesArray();

        let uuid = uuidv4();
        let guid = storageAvailable() ? localStorage.getItem('guid') : null;
        if (guid) {
            uuid = guid;
        }
        if (storageAvailable()) {
            localStorage.setItem('guid', uuid);
        }
        setGuid(uuid);

        let storedVotes = storageAvailable() ? localStorage.getItem('votes_2026') : null;
        if (storedVotes) {
            // console.log('Got stored votes: ', storedVotes);
            const votesSplit = storedVotes.split(',');
            for (let i = 0; i < votesSplit.length; i++) {
                votesSplit[i] = Number(votesSplit[i]);
            }
            setCurrentVotes(votesSplit);
        }

        let storedVotesWithEmails = storageAvailable() ? localStorage.getItem('votes_with_emails_2026') : null;
        if (storedVotesWithEmails) {
            // console.log('Got stored votes with emails: ', storedVotesWithEmails);
            const votesWithEmailsSplit = storedVotesWithEmails.split(',');
            const votesWithEmails = [];
            for (let i = 0; i < votesWithEmailsSplit.length; i++) {
                const voteWithEmail = votesWithEmailsSplit[i].split(':');
                if (voteWithEmail.length === 2) {
                    votesWithEmails.push({
                        id: Number(voteWithEmail[0]),
                        email: voteWithEmail[1]
                    });
                } else {
                    console.error('Invalid vote with email format: ', votesWithEmailsSplit[i]);
                }
            }
            setCurrentVotesWithEmails(votesWithEmails);
        }

        refreshPhase();

        // Check for r and tnom in the URL
        // This runs in useEffect because otherwise we would keep re-rendering the page and opening the side panel
        const urlParams = new URLSearchParams(window.location.search);

        // A few different ways to pass in the restaurant or trailblazer data
        // Which one we use depends if we favour readability or shortness, I guess
        // But leaving them in means people can use any of them, guess their url etc
        const rnom = urlParams.get('rnom');
        const r = urlParams.get('r');
        const restaurant = urlParams.get('restaurant');
        const tnom = urlParams.get('tnom');
        const t = urlParams.get('t');
        const trailblazer = urlParams.get('trailblazer');

        // get confirmation code from the URL
        const confirmationCode = urlParams.get('verify');
        if (confirmationCode) {
            setShowVoteConfirmation(true);
            API_CONTROLLER.ConfirmVote(confirmationCode);
        }

        if (r) {
            const restaurantData = findRestaurantData(r);
            if (restaurantData) {
                showRestaurantInfo(restaurantData);
            }
        } else if (restaurant) {
            const restaurantData = findRestaurantData(restaurant);
            if (restaurantData) {
                showRestaurantInfo(restaurantData);
            }
        } else if (rnom) {
            const restaurantData = findNomineeData(rnom);
            if (restaurantData) {
                showRestaurantInfo(restaurantData);
            }
        } else if (tnom) {
            const trailblazerData = findNomineeData(tnom);
            if (trailblazerData) {
                showTrailblazerInfo(trailblazerData);
            }
        } else if (t) {
            const trailblazerData = findNomineeData(t);
            if (trailblazerData) {
                showTrailblazerInfo(trailblazerData);
            }
        } else if (trailblazer) {
            const trailblazerData = findCategoryData(trailblazer);
            if (trailblazerData) {
                showTrailblazerInfo(trailblazerData);
            }
        }

        // If the url contains the word 'trailblazers', then we want to scroll to the trailblazers section
        if (window.location.search.includes('trailblazers')) {
            setTimeout(() => {
                scrollToSection('trailblazers', true);
            }
            , 1000);
        }

    }, []);

    // Check for initial region and tcat in the URL
    // This needs to be done here so it is immediate, rather than waiting for the useEffect to run
    // It works because the components use useState to set the initial values
    const urlParams = new URLSearchParams(window.location.search);

    // A couple of options for this as well...
    // Which one we use depends if we favour readability or shortness, I guess
    // But leaving them in means people can use any of them, guess their url etc
    const region = urlParams.get('region');
    const area = urlParams.get('area');
    const reg = urlParams.get('reg');
    const tcat = urlParams.get('tcat');
    const category = urlParams.get('category');
    const cat = urlParams.get('cat');

    let initialRegion = null;
    let initialTrailblazerCat = null;

    if (region) {
        const regionData = findRegionData(region);
        if (regionData) {
            initialRegion = regionData.id;
        }
    } else if (area) {
        const regionData = findRegionData(area);
        if (regionData) {
            initialRegion = regionData.id;
        }
    } else if (reg) {
        const regionData = findRegionData(reg);
        if (regionData) {
            initialRegion = regionData.id;
        }
    }
    if (tcat) {
        const trailblazerData = findCategoryData(tcat);
        if (trailblazerData) {
            initialTrailblazerCat = trailblazerData.id;
        }
    } else if (category) {
        const trailblazerData = findCategoryData(category);
        if (trailblazerData) {
            initialTrailblazerCat = trailblazerData.id;
        }
    } else if (cat) {
        const trailblazerData = findCategoryData(cat);
        if (trailblazerData) {
            initialTrailblazerCat = trailblazerData.id;
        }
    }

    return (
        <>
        {/* <span id="top"> */}
            {showRecaptcha &&
                <div className={`recaptcha-holder${showRecaptcha ? ' recaptcha-on' : ''}`}>
                    <div className='grow'></div>
                    <div className="recaptcha-panel">
                        <h1>One Last Step To<br />Confirm Your Vote...</h1>
                        <p>We're making sure every vote counts - fairly and securely.<br />Please enter your email address to receive a confirmation link.</p>
                        <p>Your vote will only be counted once you click the link in your inbox.</p>
                        
                        {!voteRegistered &&
                            <>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="email-input"
                                    autoComplete="email"
                                />

                                <ReCAPTCHA
                                    sitekey="6Lcbx7AeAAAAAG_Me-BDJNdzs7tWXw_PINyUqG8Q"
                                    onChange={captchaOnChange}
                                />

                                <button className={`big panel-button${(recaptchaState !== RECAPTCHA_STATE.VERIFIED || !isValidEmail(email)) ? ' disabled' : ''}`} onClick={(recaptchaState === RECAPTCHA_STATE.VERIFIED && isValidEmail(email)) ? submitVoteNow : null}>Send Confirmation Link</button>
                            </>
                        }
                        {voteRegistered &&
                            <>
                                <p className="vote-registered">Confirmation sent!<br />Please check your inbox to complete your vote.</p>
                            </>
                        }
                        <div className="close-vote-submit" onClick={() => setShowRecaptcha(false)}>Close</div>
                    </div>
                    <div className='grow'></div>
                </div>
            }
            {showVoteConfirmation &&
                <div className={`recaptcha-holder${showVoteConfirmation ? ' recaptcha-on' : ''}`}>
                    <div className='grow'></div>
                    <div className="recaptcha-panel">
                        <h1>Thanks for your vote!</h1>
                        <p>Your vote has been confirmed.</p>
                        <p>Feel free to explore and vote for more of your favourite Uber Eats restaurants.</p>
                        <div />
                        <div className="close-vote-submit" onClick={
                            () => {
                                // Link to www.ubereatsawards.com
                                window.location.href = 'https://www.ubereatsawards.com';
                            }
                        }>Close</div>
                    </div>
                    <div className='grow'></div>
                </div>
            }

            {currentPhase === PHASES.LAUNCHING_SOON &&
                <ComingSoon></ComingSoon>
            }

        {currentPhase !== PHASES.LAUNCHING_SOON &&
        <>
            <Nav scrollToSection={scrollToSection} currentPhase={currentPhase} scrollY={scrollY}></Nav>


<section className="hero" id="hero">
    
    {currentPhase === PHASES.WINNERS &&
        <canvas className="hero__fireworks__canvas" id="fireworks_canvas"></canvas>
    }

    <div className="hero-bg">

    <div className="container">
        {/* <div className="hero-grow"></div>
        <div className="hero-grow"></div> */}

            <div className='hero-content'>
                <img src={HeroLogo} alt="Uber Eats Restaurant of the Year 2026 logo" />
                <h1>
                    {currentPhase === PHASES.VOTE &&
                        <>VOTING NOW OPEN</>
                    }
                    {currentPhase === PHASES.VOTE_ENDED &&
                        <>VOTING CLOSED</>
                    }
                    {currentPhase === PHASES.FINALISTS &&
                        <>MEET YOUR REGIONAL WINNERS</>
                    }
                    {currentPhase === PHASES.WINNERS &&
                        <>CONGRATULATIONS TO OUR WINNERS</>
                    }
                </h1>
                <button className="light" onClick={() => scrollToSection('roty')}>
                    {currentPhase === PHASES.VOTE &&
                        <>Vote now</>
                    }
                    {currentPhase === PHASES.FINALISTS &&
                        <>View Regional Winners</>
                    }
                    {currentPhase === PHASES.WINNERS &&
                        <>View winners</>
                    }
                    {currentPhase === PHASES.VOTE_ENDED &&
                        <>View restaurants</>
                    }
                </button>
            </div>

        {/* <h1 className="hero__title">
            {currentPhase === PHASES.VOTE &&
                <>WE'RE BACK!</>
            }
            {currentPhase === PHASES.VOTE_ENDED &&
                <>VOTING CLOSED</>
            }
            {currentPhase === PHASES.FINALISTS &&
                <div className="hero__title-small">MEET YOUR REGIONAL WINNERS</div>
            }
            {currentPhase === PHASES.WINNERS &&
                <div className="hero__title-small-2">CONGRATULATIONS!</div>
            } */}

            {/* <span
                className="hero__title-word"
                style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transformOrigin: "50% 100%",
                    opacity: 1,
                    transform: "translate3d(0px, 26.6904px, 0px)"
                }}
            >
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>V</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>O</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>T</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>I</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>N</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>G</span>

            </span>
            &nbsp;
            <span
                className="hero__title-word"
                style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    transformOrigin: "50% 100%",
                    opacity: 1,
                    transform: "translate3d(0px, 26.6904px, 0px)"
                }}
            >
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>O</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate3d(0px, -6.0668px, 0px)" }}>P</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>E</span>
                <span className="hero__title-letter" style={{ display: "inline-block", translate: "none", rotate: "none", scale: "none", transform: "translate(0px, -8px)" }}>N</span>
            </span> */}
        {/* </h1>
        <div className="hero-grow"></div>
        <div className="hero__subtitle">
            <span className="hero__subtitle-word">
                {currentPhase === PHASES.VOTE &&
                    <>VOTING FOR RESTAURANT<br/>OF THE YEAR 2026<br />IS NOW OPEN</>
                }
                {currentPhase === PHASES.VOTE_ENDED &&
                    <>REGIONAL WINNERS TO BE<br/>ANNOUNCED SOON</>
                }
                {currentPhase === PHASES.FINALISTS &&
                    <>THE RESTAURANT OF THE YEAR<br />2026 REGIONAL WINNERS<br />ARE HERE</>
                }
                {currentPhase === PHASES.WINNERS &&
                    <>INTRODUCING THE<br/>WINNERS OF THE RESTAURANT<br />OF THE YEAR AWARDS 2026</>
                }
            </span> */}
            {/* <span
                className="hero__subtitle-word"
                style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    opacity: 1,
                    transform: "translate3d(0px, -32.0285px, 0px) scale(1.0045, 1.0045)"
                }}
            >
                RESTAURANT
            </span>
            <span
                className="hero__subtitle-word"
                style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    opacity: 1,
                    transform: "translate3d(0px, -3.5407px, 0px)"
                }}
            >
                OF THE YEAR
            </span>
            <span
                className="hero__year-subtitle-word"
                style={{
                    translate: "none",
                    rotate: "none",
                    scale: "none",
                    opacity: 1,
                    transform: "translate3d(0px, -32.0285px, 0px) scale(1.0197, 1.0197)"
                }}
            >
                2<span className="hero__subtitle-logo">
                    <img
                        decoding="async"
                        src={HeroGif}
                        alt="Uber Eats Awards Logo"
                        className="hero__logo-badge"
                        style={{
                            translate: "none",
                            rotate: "none",
                            scale: "none",
                            opacity: 1,
                            transform: "translate3d(0px, -7.1174px, 0px) scale(1.0497, 1.0497)"
                        }}
                    />
                </span>25
            </span> */}
        {/* </div> */}

        {/*currentPhase !== PHASES.WINNERS &&
            <>
                <div
                    className="hero__image-container hero__image-container--burger"
                    style={{
                        translate: "none",
                        rotate: "none",
                        scale: "none",
                        transformOrigin: "50% 50%",
                        opacity: 1,
                        transform: "translate3d(0px, 20.6514px, 0px) rotate(6.8469deg) scale(1.0435, 1.0435)"
                    }}
                >
                    <img decoding="async" src={HeroBurger} alt="Burger" className="hero__image" />
                </div>
                <div
                    className="hero__image-container hero__image-container--salad"
                    style={{
                        translate: "none",
                        rotate: "none",
                        scale: "none",
                        transformOrigin: "50% 50%",
                        opacity: 1,
                        transform: "translate3d(0px, 10.4769px, 0px) rotate(-3.4923deg) scale(1.0279, 1.0279)"
                    }}
                >
                    <img decoding="async" src={HeroSalad} alt="Salad" className="hero__image" />
                </div>
            </>
        */}
        {/* <div className="hero-grow"></div>
        <div
            className="hero__cta"
            style={{
                translate: "none",
                rotate: "none",
                scale: "none",
                opacity: 1,
                transform: "translate3d(0px, -10.6762px, 0px) scale(1.0028, 1.0028)"
            }}
        >
            {/* <a href="https://ubereatsawards.de/#voting" className="hero__cta-button hover-scale heartbeat">
                <span>VOTE NOW</span>
            </a> */}
            {/* <button className="light big" onClick={() => scrollToSection('roty')}>
                {currentPhase === PHASES.VOTE &&
                    <>Vote now</>
                }
                {currentPhase === PHASES.FINALISTS &&
                    <>View Regional Winners</>
                }
                {currentPhase === PHASES.WINNERS &&
                    <>View winners</>
                }
                {currentPhase === PHASES.VOTE_ENDED &&
                    <>View restaurants</>
                }
            </button>
        </div> */}
        {/* <div className="hero-grow"></div>
        <div className="hero-grow"></div>
        <div className="hero-grow"></div> */}
    </div>

    </div>

    <div
        className="hero__ticker"
        style={{
            translate: "none",
            rotate: "none",
            scale: "none",
            opacity: 1,
            transform: "translate(0px, 0px)"
        }}
    >
        <div
            className="hero__ticker-content"
            style={{
                translate: "none",
                rotate: "none",
                scale: "none",
                transform: "translate3d(-34.9287%, 0px, 0px)"
            }}
        >
            {currentPhase === PHASES.VOTE &&
                <>
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                    <strong className="green">FAVOURITE RESTAURANT</strong> <strong>VOTE NOW FOR YOUR</strong>&nbsp;
                </>
            }
            {currentPhase === PHASES.FINALISTS &&
                <>
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                    <strong className="green">RESTAURANT OF THE YEAR</strong> <strong>2026</strong>&nbsp;
                </>
            }
            {currentPhase === PHASES.VOTE_ENDED &&
                <>
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                    <strong className="green">VOTING IS NOW CLOSED</strong> <strong>CHECK BACK SOON</strong>&nbsp;
                </>
            }
            {currentPhase === PHASES.WINNERS &&
                <>
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                    <strong className="green">CONGRATULATIONS TO THE WINNERS</strong> <strong>THANKS FOR VOTING</strong>&nbsp;
                </>
            }
        </div>
    </div>
</section> 



            {/* <AboutHeader scrollToSection={scrollToSection} phase={currentPhase}></AboutHeader> */}
            <ROTYSection showRestaurantInfo={showRestaurantInfo} instagramFunction={goToInstagram} orderFunction={goToOrder} voteFunction={registerVote} phase={currentPhase} votes={currentVotes} initialRegion={initialRegion} cardTransitionInFunction={cardTransitionInFunction} cardTransitionOutFunction={cardTransitionOutFunction} scrollAnimInHandler={scrollAnimInHandler}></ROTYSection>
            <hr />
            {currentPhase !== PHASES.LAUNCHING_SOON && currentPhase !== PHASES.VOTE_ENDED && currentPhase !== PHASES.FINALISTS && currentPhase !== PHASES.WINNERS &&
                <>
                    <TrailblazersSection showTrailblazerInfo={showTrailblazerInfo} instagramFunction={goToInstagram} orderFunction={goToOrder} infoFunction={showTrailblazerInfo} phase={currentPhase} initialCategory={initialTrailblazerCat} cardTransitionInFunction={cardTransitionInFunction} cardTransitionOutFunction={cardTransitionOutFunction}></TrailblazersSection>
                    {currentPhase !== PHASES.WINNERS &&
                        <hr />
                    }
                </>
            }
            {currentPhase !== PHASES.WINNERS && currentPhase !== PHASES.VOTE_ENDED && currentPhase !== PHASES.FINALISTS &&
                <PreviousWinnersSection showPreviousWinners={showPreviousWinners} showRestaurantInfo={showRestaurantInfo} instagramFunction={goToInstagram} orderFunction={goToOrder}></PreviousWinnersSection>
            }
            {/* <hr />
            <FaqSection></FaqSection> */}
            {(currentPhase === PHASES.VOTE_ENDED || currentPhase === PHASES.FINALISTS || currentPhase === PHASES.WINNERS) &&
                <>
                    {(currentPhase === PHASES.FINALISTS || currentPhase === PHASES.WINNERS) &&
                        <>
                            <section className="standard-section fit-content" id="trailblazers">
                                <div className="section-container">
                                    <div className='content'>
                                        <div className="column roty-section-heading">
                                            <h1 className="extra-bottom-pad">2026 Anniversary Awards</h1>
                                            {currentPhase === PHASES.FINALISTS &&
                                                <p className="subheading">As Uber Eats celebrates its tenth birthday in the UK in 2026, the fifth Restaurant of the Year Awards will include two special anniversary categories. These prizes are being judged by a celebrity guest, with all to be revealed at the ceremony in September…</p>
                                            }
                                            {currentPhase === PHASES.WINNERS &&
                                                <div className="cards-container">
                                                    <RestaurantCard key={'tb_1'} bigCard={true} showTrailblazerWinnerBanner={true} category={TRAILBLAZER_CATEGORIES.next_gen.label} icon={TRAILBLAZER_CATEGORIES.next_gen.icon} trailblazer={EMPTY_TRAILBLAZER} infoFunction={showTrailblazerInfo} instagramFunction={() => {}} orderFunction={() => {}} finalist={() => {}} showWinner={() => {}} />
                                                    <RestaurantCard key={'tb_2'} bigCard={true} showTrailblazerWinnerBanner={true} category={TRAILBLAZER_CATEGORIES.titan_trailblazer.label} icon={TRAILBLAZER_CATEGORIES.titan_trailblazer.icon} trailblazer={EMPTY_TRAILBLAZER} infoFunction={showTrailblazerInfo} instagramFunction={() => {}} orderFunction={() => {}} finalist={() => {}} showWinner={() => {}} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <hr />
                        </>
                    }
                    <section className="standard-section" id="judgingVideo">
                        <div className="section-container">
                            <div className='content'>
                                <div className="column">
                                    {currentPhase !== PHASES.FINALISTS && currentPhase !== PHASES.WINNERS &&
                                        <h1 className="extra-bottom-pad">Our 2025 finalists</h1>
                                    }
                                    {currentPhase === PHASES.FINALISTS &&
                                        <h1 className="extra-bottom-pad">Our 2025 finalists</h1>
                                    }
                                    {currentPhase === PHASES.WINNERS &&
                                        <h1 className="extra-bottom-pad">Check out our 2026 finalists</h1>
                                    }
                                    {/* Video of judging at vids/UBER_ROTY_JUDGING_DAY.mov */}
                                    <div className="standard-video-holder">
                                        <video controls>
                                            <source src="./vids/UBER_ROTY_JUDGING_DAY.mov" type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            }
            <hr />
            <Footer></Footer>
            {showingPreviousWinners &&
                <InfoPopout closedCallback={previousWinnersClosedCallback}>
                    <div className="info-pop-content-holder">
                        <div className="prev-winners-pop-content">
                            <div className="prev-winners-pop-scroll-area">
                                <h2 className="prev-winners">Restaurant of the Year 2025 winners</h2>
                                <p className="prev-winners">Congratulations to everyone at Silver's Deli for being named Uber Eats Restaurant of the Year 2025 and winning £100,000.</p>
                                <PrevWinnerCard
                                    winner={PREV_WINNERS.roty2025}
                                    icon={ROTY_WINNER_ICON}
                                    category='Restaurant of the Year 2025'
                                    instagramFunction={goToInstagram}
                                    orderFunction={goToOrder}
                                    shareFunction={share}
                                />
                                <h2 className="prev-winners">2025 Trailblazer Award winners</h2>
                                <PrevWinnerCard
                                    winner={PREV_WINNERS.femaleChef2025}
                                    icon={FEMALE_CHEF_ICON}
                                    category='Female Chef of the Year Winner'
                                    instagramFunction={goToInstagram}
                                    orderFunction={goToOrder}
                                    shareFunction={share}
                                />
                                <PrevWinnerCard
                                    winner={PREV_WINNERS.sustainable2025}
                                    icon={SUSTAINABLE_RESTAURANT_ICON}
                                    category='Sustainable Restaurant of the Year Winner'
                                    instagramFunction={goToInstagram}
                                    orderFunction={goToOrder}
                                    shareFunction={share}
                                />
                                <PrevWinnerCard
                                    winner={PREV_WINNERS.socialImpact2025}
                                    icon={SOCIAL_IMPACT_ICON}
                                    category='Social Impact Restaurant of the Year Winner'
                                    instagramFunction={goToInstagram}
                                    orderFunction={goToOrder}
                                    shareFunction={share}
                                />
                                <PrevWinnerCard
                                    winner={PREV_WINNERS.health2025}
                                    icon={HEALTH_FOCUSED_ICON}
                                    category='Health Focused Restaurant of the Year Winner'
                                    instagramFunction={goToInstagram}
                                    orderFunction={goToOrder}
                                    shareFunction={share}
                                />
                            </div>
                        </div>
                    </div>
                </InfoPopout>
            }
            {showingRestaurantInfo &&
                <InfoPopout closedCallback={restaurantInfoClosedCallback}>
                    <div className="info-pop-content-holder">
                        {(!Array.isArray(restaurantInfoData.image) || (FORCE_RESTAURANT_PLACEHOLDER && restaurantInfoData !== GetPreviousOverallWinner())) &&
                            <div className="info-pop-image" style={{ backgroundImage: `url(./img/${FORCE_RESTAURANT_PLACEHOLDER ? RESTAURANT_PLACEHOLDER.image[0] : restaurantInfoData.image})` }}></div>
                        }
                        {Array.isArray(restaurantInfoData.image) && (!FORCE_RESTAURANT_PLACEHOLDER || restaurantInfoData === GetPreviousOverallWinner()) &&
                            <Carousel
                                swipeable={restaurantInfoData.image.length > 1}
                                draggable={restaurantInfoData.image.length > 1}
                                showDots={restaurantInfoData.image.length > 1}
                                customDot={<CustomDot />}
                                arrows={restaurantInfoData.image.length > 1}
                                responsive={{ all: { breakpoint: { min: 0, max: 1000000 }, items: 1 } }}
                                ssr={false} // means to render carousel on server-side.
                                infinite={true}
                                autoPlay={false /*restaurantInfoData.image.length > 1*/}
                                autoPlaySpeed={3000}
                                keyBoardControl={false}
                                transitionDuration={500}
                                containerClass=""
                                dotListClass=''
                            >
                                {
                                    restaurantInfoData.image.map((image, index) => {
                                        return (
                                            <div key={index} className="info-pop-image" style={{ backgroundImage: `url(./img/restaurants/${image}?v=${CACHE_BUSTING_VERSION})` }}></div>
                                        )
                                    })
                                }
                            </Carousel>
                        }
                        <div className="info-pop-content">
                            <h2 className="restaurant-card__info__name">{(FORCE_RESTAURANT_PLACEHOLDER && restaurantInfoData !== GetPreviousOverallWinner()) ? RESTAURANT_PLACEHOLDER.name : restaurantInfoData.name}</h2>
                            <div className="restaurant-card__info__location">
                                <img className='small-info-icon' src={LocationIcon} alt='Location icon' />
                                <p>{restaurantInfoData.location || AREAS_BY_ID[restaurantInfoData.region].label}</p>
                            </div>
                            <div className="info-pop-scroll-area">
                                <p>{nl2br(FORCE_RESTAURANT_PLACEHOLDER && restaurantInfoData !== GetPreviousOverallWinner() ? RESTAURANT_PLACEHOLDER.description : restaurantInfoData.description)}</p>
                            </div>
                        </div>
                        <div className="info-pop-buttons">
                            <div className='restaurant-card__info__buttons'>
                                <button className="restaurant-card__info__buttons__info square light" onClick={() => share(restaurantInfoData, restaurantInfoData.id)}>{SHARE_ICON}</button>
                                {restaurantInfoData?.instagram !== '' && restaurantInfoData?.instagram !== undefined && restaurantInfoData?.instagram !== null && !restaurantInfoData?.instagram?.endsWith('instagram.com/') && !restaurantInfoData?.instagram?.endsWith('instagram.com') &&
                                    <button className="side-card__info__buttons__instagram square light" onClick={() => goToInstagram(restaurantInfoData)}>{INSTA_ICON}</button>
                                }
                                <button className={`side-card__info__buttons__order grow${(currentPhase === PHASES.VOTE && currentVotes.indexOf(restaurantInfoData.id) === -1) ? ' light' : ' black'} order-button`} onClick={() => goToOrder(restaurantInfoData)}>Order on Uber Eats</button>
                            </div>
                            {currentPhase === PHASES.VOTE &&
                                <>
                                    {currentVotes.indexOf(restaurantInfoData.id) === -1 &&
                                        <button className="black" onClick={() => registerVote(restaurantInfoData.id, restaurantInfoData.region, restaurantInfoData.name)}>Vote now</button>
                                    }
                                    {currentVotes.indexOf(restaurantInfoData.id) !== -1 &&
                                        <div className='voted-holder side-panel'>Thanks for voting</div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </InfoPopout>
            }
            {showingTrailblazerInfo &&
                <InfoPopout closedCallback={trailblazerInfoClosedCallback}>
                    <div className="info-pop-content-holder">
                        {!Array.isArray(trailblazerInfoData.image) &&
                            <div className="info-pop-image" style={{ backgroundImage: `url(./img/${trailblazerInfoData.image})` }}></div>
                        }
                        {Array.isArray(trailblazerInfoData.image) &&
                            <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                customDot={<CustomDot />}
                                arrows={true}
                                responsive={{ all: { breakpoint: { min: 0, max: 1000000 }, items: 1 } }}
                                ssr={false} // means to render carousel on server-side.
                                infinite={true}
                                autoPlay={false}
                                autoPlaySpeed={3000}
                                keyBoardControl={false}
                                transitionDuration={500}
                                containerClass=""
                                dotListClass=''
                            >
                                {
                                    trailblazerInfoData.image.map((image, index) => {
                                        return (
                                            <div key={index} className="info-pop-image" style={{ backgroundImage: `url(./img/${image})` }}></div>
                                        )
                                    })
                                }
                            </Carousel>
                        }
                        <div className="info-pop-content">
                            <h2 className='trailblazer-card__info__name'>{trailblazerInfoData.name}</h2>
                            {/* <h3>{trailblazerInfoData.restaurant}</h3> */}
                            <div className='trailblazer-card__info__location'>
                                <img className='small-info-icon' src={LocationIcon} alt='Location icon' />
                                <p>{trailblazerInfoData.location}</p>
                            </div>
                            <div className="info-pop-scroll-area">
                                <p>{nl2br(trailblazerInfoData.description)}</p>
                            </div>
                        </div>
                        <div className="info-pop-buttons">
                            <div className='trailblazer-card__info__buttons'>
                                {/* <button className='trailblazer-card__info__buttons__info square light' onClick={() => share(restaurantInfoData)}>{SHARE_ICON}</button> */}
                                <button className='side-card__info__buttons__instagram square light' onClick={() => goToInstagram(trailblazerInfoData)}>{INSTA_ICON}</button>
                                <button className='trailblazer-card__info__buttons__order black order-button' onClick={() => goToOrder(trailblazerInfoData)}>Order on Uber Eats</button>
                            </div>
                        </div>
                    </div>
                </InfoPopout>
            }
        </>
        }
        {/* </span> */}
        </>
    );
}